<template>
	<vs-table
		max-items="40"
		:hoverFlat="true"
		:notSpacer="true"
		:data="subTransactionTypes"
		v-if="subTransactionTypes && subTransactionTypes.length > 0"
	>
		<template slot-scope="{data}">
			<vs-tr
				:data="subTransactionTypes"
				:key="index"
				v-for="(subTransactionType, index) in data"
			>
				<vs-td style="padding-left: 0px !important;">
					<p class="product-name font-medium truncate">{{ subTransactionType.name }}</p>
				</vs-td>
				<vs-td class="whitespace-no-wrap">
					<div class="flex pull-right">
						<vx-tooltip text="Módosítás">
							<vs-button
								type="border"
								size="small"
								icon-pack="feather"
								icon="icon-edit"
								class="mr-2"
								color="dark"
								@click.stop="editData(subTransactionType)"
							></vs-button>
						</vx-tooltip>
						<vx-tooltip text="Törlés">
							<vs-button
								type="border"
								size="small"
								icon-pack="feather"
								icon="icon-trash-2"
								color="danger"
								class="mr-2"
								@click.stop="deleteData(subTransactionType.id)"
							></vs-button>
						</vx-tooltip>
					</div>
				</vs-td>
				<template
					class="expand-user"
					slot="expand"
				>
					<phase-table
						:phases="subTransactionType.phases"
						@editPhase="editPhase"
						@deletePhase="deletePhase"
					></phase-table>
				</template>
			</vs-tr>
		</template>
	</vs-table>
</template>

<script>
import PhaseTable from '@/views/transaction-types/components/PhaseTable.vue'

export default {
	components: {
		PhaseTable
	},
	props: {
		subTransactionTypes: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			chartOptions: null
		}
	},
	watch: {
	},
	computed: {
	},
	methods: {
		editData(data) {
			this.$emit('editData', data)
		},
		deleteData(id) {
			this.$emit('deleteData', id)
		},
		editPhase(data) {
			this.$emit('editPhase', data)
		},
		deletePhase(id) {
			console.log('Delete phase 2 ');
			this.$emit('deletePhase', id)
		},
		getStatusColor(status) {
			switch (status) {
				case 'in_progress':
					return 'warning'

				case 'done':
					return 'success'

				case 'obstacle':
					return 'danger'

				default:
					return 'dark'
			}
		}

	}
}
</script>
